(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5563],{

/***/ 78007:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support",
      function () {
        return __webpack_require__(56758);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VerifyCodeInput_hoc; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./packages/ui/src/components/verifyCodeInput/verifyCodeInput.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 22px !important;\n  line-height: 22px !important;\n  padding: 0 4px !important;\n\n  span {\n    ",
        "\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  &::before {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SendEmailButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z)(_templateObject(), mixins/* typography */.cp("p2"), colors.B1);

;// CONCATENATED MODULE: ./packages/ui/src/components/verifyCodeInput/verifyCodeInput.constant.js
var STATE_NORMAL = 0;
var STATE_SENDING = 1;
var STATE_LIMIT = 2;

// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 227 modules
var es = __webpack_require__(36486);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./packages/ui/src/components/countDown/countDown.styled.js
function countDown_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function countDown_styled_templateObject() {
    var data = countDown_styled_taggedTemplateLiteral([
        "\n  text-transform: none;\n"
    ]);
    countDown_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Text = styled_components_browser_esm/* default.span */.ZP.span(countDown_styled_templateObject());

;// CONCATENATED MODULE: ./packages/ui/src/components/countDown/CountDown.component.js





var defaultFormatter = function(ms) {
    return Math.round(ms / 1000);
};
var CountDown = function(param) {
    var total = param.total, counterRef = param.counterRef, onFinished = param.onFinished, _formatter = param.formatter, formatter = _formatter === void 0 ? defaultFormatter : _formatter, _interval = param.interval, interval = _interval === void 0 ? 1000 : _interval, children = param.children;
    var ref = (0,react.useState)(), time1 = ref[0], setTime = ref[1];
    var ref1 = (0,react.useState)(0), resetVersion = ref1[0], setResetVersion = ref1[1];
    if (counterRef && "current" in counterRef) {
        counterRef.current = {
            reset: function() {
                setResetVersion(resetVersion + 1);
            }
        };
    }
    (0,react.useEffect)(function() {
        setTime(total);
        var handle = setInterval(function() {
            setTime(function(time) {
                if (time >= interval) {
                    return time - interval;
                } else {
                    clearInterval(handle);
                    onFinished && onFinished();
                    return 0;
                }
            });
        }, interval);
        return function() {
            clearInterval(handle);
        };
    }, [
        total,
        interval,
        resetVersion,
        onFinished
    ]);
    return es.is(Function, children) ? children(formatter(time1)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
        children: formatter(time1)
    });
};
CountDown.propTypes = {
    total: (prop_types_default()).number.isRequired,
    counterRef: (prop_types_default()).object,
    onFinished: (prop_types_default()).func,
    formatter: (prop_types_default()).func,
    interval: (prop_types_default()).number,
    children: (prop_types_default()).func
};
/* harmony default export */ var CountDown_component = (CountDown);

;// CONCATENATED MODULE: ./packages/ui/src/components/verifyCodeInput/VerifyCodeInput.hoc.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var VerifyCodeSuffix = function(param) {
    var state = param.state, disabled = param.disabled, sendVerifyCodeBtnText = param.sendVerifyCodeBtnText, onClickSendButton = param.onClickSendButton, countDownTotal = param.countDownTotal, countDownFormatter = param.countDownFormatter, onCountDownFinished = param.onCountDownFinished;
    switch(state){
        case STATE_LIMIT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SendEmailButton, {
                type: "link",
                disabled: true,
                size: "small",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown_component, {
                    total: countDownTotal,
                    onFinished: onCountDownFinished,
                    formatter: countDownFormatter
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SendEmailButton, {
                disabled: disabled,
                loading: state === STATE_SENDING,
                type: "link",
                onClick: onClickSendButton,
                size: "small",
                children: sendVerifyCodeBtnText
            });
    }
};
var withVerifyCode = function(Input) {
    return function(_param) {
        var sendVerifyCode = _param.sendVerifyCode, sendVerifyCodeBtnText = _param.sendVerifyCodeBtnText, limitSeconds = _param.limitSeconds, countDownFormatter = _param.countDownFormatter, _initialLimited = _param.initialLimited, initialLimited = _initialLimited === void 0 ? false : _initialLimited, buttonDisabled = _param.buttonDisabled, props = _objectWithoutProperties(_param, [
            "sendVerifyCode",
            "sendVerifyCodeBtnText",
            "limitSeconds",
            "countDownFormatter",
            "initialLimited",
            "buttonDisabled"
        ]);
        var ref = (0,react.useState)(initialLimited ? STATE_LIMIT : STATE_NORMAL), state = ref[0], setState = ref[1];
        var onCountDownFinished = (0,react.useCallback)(function() {
            return setState(STATE_NORMAL);
        }, []);
        var onClickSendButton = function() {
            if (state) return;
            var prevState = state;
            setState(STATE_SENDING);
            sendVerifyCode().then(function() {
                setState(STATE_LIMIT);
            }).catch(function() {
                setState(prevState);
            });
        };
        var suffixProps = {
            countDownFormatter: countDownFormatter,
            countDownTotal: limitSeconds,
            disabled: buttonDisabled || props.disabled,
            onClickSendButton: onClickSendButton,
            onCountDownFinished: onCountDownFinished,
            sendVerifyCodeBtnText: sendVerifyCodeBtnText,
            state: state
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, _objectSpread({}, props, {
            suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCodeSuffix, _objectSpread({}, suffixProps))
        }));
    };
};
/* harmony default export */ var VerifyCodeInput_hoc = (withVerifyCode);


/***/ }),

/***/ 31719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Container(_param) {
    var children = _param.children, fluid = _param.fluid, classNameInput = _param.className, rest = _objectWithoutProperties(_param, [
        "children",
        "fluid",
        "className"
    ]);
    var className = "PingCAPContainer";
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, classNameInput, (_obj = {}, _defineProperty(_obj, "".concat(className, "-fluid"), fluid), _defineProperty(_obj, "".concat(className, "-normal"), !fluid), _obj))
    }, rest, {
        children: children
    }));
};


/***/ }),

/***/ 80344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31719);

/* harmony default export */ __webpack_exports__["Z"] = (_Container__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 56758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/components/Container/index.ts
var Container = __webpack_require__(80344);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./packages/datasource/src/api/support/index.ts
var support = __webpack_require__(6769);
// EXTERNAL MODULE: ./packages/ui/src/components/verifyCodeInput/VerifyCodeInput.hoc.js + 4 modules
var VerifyCodeInput_hoc = __webpack_require__(98537);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 5 modules
var input = __webpack_require__(79531);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./node_modules/antd/es/result/index.js + 5 modules
var result = __webpack_require__(33859);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(32808);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/form-item/index.js
var form_item = __webpack_require__(29553);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/support/_components/SupportForm.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 24px;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 759px;\n  background: #ffffff;\n  border: 1px solid #ececec;\n  border-radius: 12px;\n  padding: 48px 76px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 24px;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 759px;\n  background: #ffffff;\n  border: 1px solid #ececec;\n  border-radius: 12px;\n  padding: 48px 76px;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  line-height: 22.4px;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  &:before {\n    display: inline-block;\n    margin-right: 4px;\n    color: ",
        ";\n    font-size: 14px;\n    font-family: 'SimSun,sans-serif';\n    line-height: 1;\n    content: '*';\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SupportContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var SupportForm = (0,styled_components_browser_esm/* default */.ZP)("form")(_templateObject1());
var SupportFormDescription = (0,styled_components_browser_esm/* default */.ZP)("p")(_templateObject2());
var SupportFormRequiredLabel = (0,styled_components_browser_esm/* default */.ZP)("span")(_templateObject3(), colors/* AntD.error */.y.error);

// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(59874);
;// CONCATENATED MODULE: ./src/pages/support/_components/SupportFormContent.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var INITIAL_VALUES = {
    name: "",
    company: "",
    consult_detail: "",
    phone: "",
    phone_code: ""
};
var fields = {
    name: {
        placeholder: "\u8F93\u5165\u60A8\u7684\u59D3\u540D",
        name: "name"
    },
    company: {
        placeholder: "\u8BF7\u8F93\u5165\u60A8\u7684\u516C\u53F8\u540D",
        name: "company"
    },
    consult_detail: {
        placeholder: "\u8BF7\u6DFB\u52A0\u63CF\u8FF0",
        name: "consult_detail"
    },
    phone: {
        placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
        name: "phone"
    },
    phone_code: {
        placeholder: "\u9A8C\u8BC1\u7801",
        name: "phone_code"
    }
};
var unauthorizedSchema = es/* object */.Ry({
    phone: es/* string */.Z_().required("\u8BF7\u8F93\u5165\u624B\u673A\u53F7"),
    phone_code: es/* string */.Z_().required("\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"),
    name: es/* string */.Z_().min(2, "\u8BF7\u8F93\u5165\u6709\u6548\u59D3\u540D").required("\u672A\u586B\u5199\u59D3\u540D"),
    company: es/* string */.Z_().min(2, "\u8BF7\u8F93\u5165\u6709\u6548\u516C\u53F8\u540D").required("\u672A\u586B\u5199\u516C\u53F8"),
    consult_detail: es/* string */.Z_()
});
var authorizedSchema = es/* object */.Ry({
    name: es/* string */.Z_().min(2, "\u8BF7\u8F93\u5165\u6709\u6548\u59D3\u540D").required("\u672A\u586B\u5199\u59D3\u540D"),
    company: es/* string */.Z_().min(2, "\u8BF7\u8F93\u5165\u6709\u6548\u516C\u53F8\u540D").required("\u672A\u586B\u5199\u516C\u53F8"),
    consult_detail: es/* string */.Z_()
});
var VerifyCodeInput = (0,VerifyCodeInput_hoc/* default */.Z)(input/* default */.Z);
function SupportFormContent(param) {
    var authorized = param.authorized;
    var ref = (0,react.useState)(false), agree = ref[0], setAgree = ref[1];
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var ref2 = (0,react.useState)(false), succeed = ref2[0], setSucceed = ref2[1];
    var onSubmit = utils/* form.wrapFormikSubmitFunction */.cr.wrapFormikSubmitFunction(function(values) {
        setIsSubmitting(true);
        return support.submitSupportForm(_objectSpread({}, values)).then(function() {
            message/* default.success */.ZP.success("\u63D0\u4EA4\u6210\u529F");
            setSucceed(true);
        }).finally(function() {
            setIsSubmitting(false);
        });
    });
    if (succeed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(result/* default */.ZP, {
                status: "success",
                title: "\u63D0\u4EA4\u6210\u529F",
                subTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "\u63D0\u4EA4\u6210\u529F\uFF01\u6211\u4EEC\u5C06\u5728 ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: "1 \u4E2A\u5DE5\u4F5C\u65E5\u5185"
                        }),
                        " \u548C\u60A8\u8054\u7CFB\uFF0C\u4E3A\u60A8\u63D0\u4F9B\u6240\u9700\u7684\u5546\u4E1A\u652F\u6301\u548C\u54A8\u8BE2\u670D\u52A1\u3002\u611F\u8C22\u60A8\u5BF9 TiDB \u7684\u4FE1\u4EFB\u4E0E\u652F\u6301\uFF0C\u671F\u5F85\u4E0E\u60A8\u7684\u8FDB\u4E00\u6B65\u4EA4\u6D41\u3002"
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: INITIAL_VALUES,
        validationSchema: authorized ? authorizedSchema : unauthorizedSchema,
        onSubmit: onSubmit,
        children: function(formik) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SupportForm, {
                onSubmit: formik.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportFormDescription, {
                        children: "\u4E3A\u4E86\u66F4\u597D\u5730\u4E3A\u60A8\u63D0\u4F9B\u5546\u4E1A\u652F\u6301\u548C\u4E2A\u6027\u5316\u670D\u52A1\uFF0C\u8BF7\u586B\u5199\u4EE5\u4E0B\u4FE1\u606F\u3002\u6211\u4EEC\u627F\u8BFA\u4FDD\u62A4\u60A8\u7684\u9690\u79C1\uFF0C\u5E76\u4EC5\u5C06\u4FE1\u606F\u7528\u4E8E\u63D0\u4F9B\u670D\u52A1\uFF0C\u6211\u4EEC\u5C06\u5728 1 \u4E2A\u5DE5\u4F5C\u65E5\u5185\u548C\u60A8\u8054\u7CFB\u3002"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        gutter: 8,
                        children: [
                            !authorized && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    gutter: 16,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            xs: 18,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                                                name: "phone",
                                                colon: false,
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportFormRequiredLabel, {
                                                    children: "\u624B\u673A\u53F7"
                                                }),
                                                labelCol: {
                                                    xs: 24
                                                },
                                                labelAlign: "left",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, _objectSpread({
                                                    id: "phone"
                                                }, fields.phone, {
                                                    onChange: formik.handleChange,
                                                    disabled: isSubmitting
                                                }))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            xs: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                                                name: "phone_code",
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "\xa0"
                                                }),
                                                colon: false,
                                                labelCol: {
                                                    xs: 24
                                                },
                                                labelAlign: "left",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCodeInput, _objectSpread({
                                                    id: "phone_code"
                                                }, fields.phone_code, {
                                                    onChange: formik.handleChange,
                                                    sendVerifyCode: _asyncToGenerator(runtime_default().mark(function _callee() {
                                                        return runtime_default().wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    return _ctx.abrupt("return", support.sendPhoneCode({
                                                                        phone: formik.values.phone
                                                                    }));
                                                                case 1:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    })),
                                                    limitSeconds: 60,
                                                    buttonDisabled: !formik.values.phone,
                                                    sendVerifyCodeBtnText: "\u53D1\u9001",
                                                    initialLimited: false,
                                                    countDownFormatter: function(a) {
                                                        return "".concat(a);
                                                    },
                                                    disabled: isSubmitting
                                                }))
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                                    name: "name",
                                    colon: false,
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportFormRequiredLabel, {
                                        children: "\u59D3\u540D"
                                    }),
                                    labelCol: {
                                        xs: 24
                                    },
                                    labelAlign: "left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, _objectSpread({
                                        id: "name"
                                    }, fields.name, {
                                        onChange: formik.handleChange,
                                        disabled: isSubmitting
                                    }))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                                    name: "company",
                                    colon: false,
                                    labelCol: {
                                        xs: 24
                                    },
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportFormRequiredLabel, {
                                        children: "\u516C\u53F8"
                                    }),
                                    labelAlign: "left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, _objectSpread({
                                        id: "company"
                                    }, fields.company, {
                                        onChange: formik.handleChange,
                                        disabled: isSubmitting
                                    }))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                                    name: "consult_detail",
                                    colon: false,
                                    labelCol: {
                                        xs: 24
                                    },
                                    label: "\u54A8\u8BE2\u4E8B\u5B9C\uFF08\u975E\u5FC5\u586B\uFF09",
                                    labelAlign: "left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default.TextArea */.Z.TextArea, _objectSpread({
                                        id: "consult_detail"
                                    }, fields.consult_detail, {
                                        onChange: formik.handleChange,
                                        disabled: isSubmitting
                                    }))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                        disabled: !agree || !formik.isValid,
                        style: {
                            marginTop: 16
                        },
                        type: "primary",
                        htmlType: "submit",
                        block: true,
                        children: "\u786E\u8BA4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_checkbox/* default */.Z, {
                        style: {
                            marginTop: 8
                        },
                        checked: agree,
                        onChange: function(ev) {
                            return setAgree(ev.target.checked);
                        },
                        disabled: isSubmitting,
                        children: [
                            "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    textDecoration: "underline"
                                },
                                href: "https://www.pingcap.cn/privacy-policy",
                                target: "_blank",
                                rel: "noopener",
                                children: "\u300A\u9690\u79C1\u534F\u8BAE\u300B"
                            })
                        ]
                    })
                ]
            });
        }
    });
}

;// CONCATENATED MODULE: ./src/pages/support/_components/SupportHeading.tsx
function SupportHeading_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SupportHeading_templateObject() {
    var data = SupportHeading_taggedTemplateLiteral([
        "\n  text-align: center;\n  margin-top: 24px;\n"
    ]);
    SupportHeading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SupportHeading_templateObject1() {
    var data = SupportHeading_taggedTemplateLiteral([
        "\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 50.4px;\n  color: #000000;\n"
    ]);
    SupportHeading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SupportHeading_templateObject2() {
    var data = SupportHeading_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n"
    ]);
    SupportHeading_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var SupportHeading = (0,styled_components_browser_esm/* default */.ZP)("div")(SupportHeading_templateObject());
var SupportHeadingTitle = (0,styled_components_browser_esm/* default */.ZP)("h1")(SupportHeading_templateObject1());
var SupportHeadingHeadline = (0,styled_components_browser_esm/* default */.ZP)("p")(SupportHeading_templateObject2());

;// CONCATENATED MODULE: ./src/pages/support/_components/decorate.png
/* harmony default export */ var decorate = ({"src":"https://img1.tidb.net/_next/static/media/decorate.d0d7716a.png","height":676,"width":1786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAANlBMVEXYnHPfhZ0vQYHqwHaRbWqxmVlnQ1bVoYIbIHnMgFjEqm6hPWSXaGm9q6/fQzqCTIJHW7Tvt6vrbsmzAAAAEnRSTlNC0aOoTJ+1IhFTtLJbudbAxctp6hk3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVQImWNgZ+Hh5GRhYGdg4GMU5BXgYmDg4GdjZeZm4gAACZYAttYxv70AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/support/index.page.tsx










function SupportPage() {
    var ref = (0,react.useContext)(context/* MeContext */.io), isMeValidating = ref.isMeValidating, meData = ref.meData;
    var isLoadingMeData = !meData && isMeValidating;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
        backgroundColor: "#e9eaee",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "\u5546\u4E1A\u652F\u6301\u54A8\u8BE2",
                description: "\u8981\u4E86\u89E3\u89C4\u5212/\u5B9E\u65BD/\u4E3B\u52A8\u5F0F\u5DE1\u68C0/\u6545\u969C\u534F\u67E5/\u6570\u636E\u5E93\u8FC1\u79FB/\u91CD\u8981\u65F6\u671F\u4FDD\u969C\u7B49\u670D\u52A1\uFF1F\n" + "\u60F3\u8981\u83B7\u5F97\u5546\u4E1A\u4E13\u5BB6\u4EA7\u54C1\u6700\u9AD8\u54CD\u5E94\u7EA7\u522B 7*24 \u652F\u6301\u670D\u52A1\uFF1F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SupportHeading, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportHeadingTitle, {
                                children: "\u5546\u4E1A\u652F\u6301\u54A8\u8BE2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SupportHeadingHeadline, {
                                children: [
                                    "\u60F3\u8981\u4E86\u89E3",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "\u89C4\u5212/\u5B9E\u65BD/\u4E3B\u52A8\u5F0F\u5DE1\u68C0/\u6545\u969C\u534F\u67E5/\u6570\u636E\u5E93\u8FC1\u79FB/\u91CD\u8981\u65F6\u671F\u4FDD\u969C"
                                    }),
                                    "\u7B49\u670D\u52A1\uFF1F",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "\u60F3\u8981\u83B7\u5F97\u5546\u4E1A\u4E13\u5BB6\u4EA7\u54C1\u6700\u9AD8\u54CD\u5E94\u7EA7\u522B ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "7*24 \u652F\u6301\u670D\u52A1"
                                    }),
                                    "\uFF1F"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                        spinning: isLoadingMeData,
                        tip: "\u52A0\u8F7D\u4E2D...",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportFormContent, {
                            authorized: !!meData
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "\u88C5\u9970\u56FE\u7247",
                        src: decorate.src,
                        width: decorate.width / 2,
                        style: {
                            display: "block",
                            maxWidth: "100%",
                            margin: "48px auto 0"
                        }
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var index_page = (SupportPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8042,9774,2888,179], function() { return __webpack_exec__(78007); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);